module.exports = __webpack_public_path__ + "img/emporte-piece-coeur-ex-voto-feuillage.48a3cc02.jpg";